import { TextInput } from "../form/TextInput";

export const ListSearch = (props) => {

  const dispatchEvent = (query) => {
    props.onSearch(query);
  }

  const onKeyAction = (ev) => {
    dispatchEvent(ev.currentTarget.value);
  }

  const onChange = (ev) => {
    dispatchEvent(ev.currentTarget.value);
  }

  return (
    <TextInput
      placeholder="Search..."
      class="h-9"
      form={props.form}
      keyaction={onKeyAction}
      input={onChange}
      name="search" />
  );
}
